import React from "react";

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
}

export const GradientText: React.FC<GradientTextProps> = ({ children, className = "" }) => (
  <span
    className={`bg-gradient-to-r from-[#26B5AA] to-[#14B8A6] bg-clip-text text-transparent ${className}`}
  >
    {children}
  </span>
);